__turbopack_context__.v({
  "className": "inter_59dee874-module__9CtR0q__className",
});
